import type { ReactNode } from "react";
import AddCommentOutlined from "@mui/icons-material/AddCommentOutlined";
import { ButtonBase, IconButton, Tooltip } from "@mui/material";
import { DEFAULT_SESSION_TITLE } from "../../../../AiToolboxSection.constants";

interface AiAssistantCreateSessionButtonProps {
  onCreateNewSession: () => void;
  children?: ReactNode;
}

export const AiAssistantCreateSessionButton = ({
  onCreateNewSession,
  children,
}: AiAssistantCreateSessionButtonProps) => {
  if (!children) {
    return (
      <Tooltip title={DEFAULT_SESSION_TITLE}>
        <IconButton
          size="small"
          onClick={onCreateNewSession}
          className="text-text-secondary hover:text-text-primary -mb-0.5"
        >
          <AddCommentOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <ButtonBase
      onClick={onCreateNewSession}
      className="text-text-secondary hover:text-text-primary inline-flex items-center gap-1"
    >
      <IconButton component="span" size="small" disableRipple>
        <AddCommentOutlined fontSize="small" />
      </IconButton>
      {children}
    </ButtonBase>
  );
};
